import { render, staticRenderFns } from "./InjuryInsuranceAdjustment.vue?vue&type=template&id=4f37e020"
import script from "./InjuryInsuranceAdjustment.vue?vue&type=script&lang=js"
export * from "./InjuryInsuranceAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports